//vendors
import React from 'react';
import classNames from "classnames";
import { RadioButton } from './radio_button';

//styles
import styles from './radio_button_group.module.scss';


export type tRadioItems = {
  value: string | number,
  label: string | JSX.Element,
  disabled: boolean,
  info?: string
};

type RadioButtonGroupProps = {
  name: string,
  items: tRadioItems[],
  onChange: (value: any) => void,
  value?: string | number,
  vertical?: boolean,
  disabled?: boolean,
  className?: string
};

export const RadioButtonGroup = (props: RadioButtonGroupProps) => {
  const handlerOnChange = (e: any) => {
    const { value } = e.target;
    const resultValue = Number.isInteger(value) ? parseInt(value) : value;
    props.onChange(resultValue);
  };
  
  return (
    <div className={classNames(styles.radioGroup, props.className, {[styles.radioGroupVertical]: props.vertical})}>
      {props.items.map((radio: tRadioItems) => {
        const isChecked = radio.value === props.value;
        return (
          <RadioButton
            key={radio.value}
            disabled={radio.disabled || props.disabled}
            value={radio.value}
            label={radio.label}
            name={props.name}
            info={radio.info}
            isChecked={isChecked}
            onChange={handlerOnChange}
          />
        )
      })}
    </div>
  )
}

RadioButtonGroup.defaultProps = {
  vertical: false,
  disabled: false
};
